import { loadStripe } from '@stripe/stripe-js'
import { config } from '../config.js'

export let OutOfStockException = function (message, items, outOfStock) {
  this.message = message
  this.name = 'UserException'
  this.availableProducts = items
  this.outOfStock = outOfStock
}

class Stripe {
  constructor() {
    this.stripeKey = config.payPublicKey
    this.stripeClient = loadStripe(this.stripeKey)
  }

  async redirect(sessionID) {
    try {
      this.stripeClient = await loadStripe(this.stripeKey)
      this.stripeClient
        .redirectToCheckout({
          sessionId: sessionID,
        })
        .then((result) => result)
        .catch((err) => {
          throw result.error.message
        })
    } catch (err) {
      throw 'We are experiencing issues.  Please try again in a few minutes.'
    }
  }

  async getStripeElement() {
    try {
      this.stripeClient = await loadStripe(this.stripeKey)
      let elements = this.stripeClient.elements()
      let element = elements.create('card', {
        iconStyle: 'solid',
        style: {
          base: {
            iconColor: '#036',
            fontWeight: 500,
            fontSize: '16px',
            fontSmoothing: 'antialiased',
          },
          invalid: {
            iconColor: '#f90f0f',
            color: '#f90f0f',
          },
        },
      })
      return element
    } catch (err) {
      throw 'We are experiencing issues.  Please try again in a few minutes.'
    }
  }

  async confirmSetupIntent(cs, cardElement) {
    // don't reinstantiate this. stripe wants us to use the same client
    // that created the card element
    await this.stripeClient
      .confirmCardSetup(cs, {
        payment_method: {
          card: cardElement,
        },
      })
      .then(function (result) {
        if (result.error) {
          // Display error.message in your UI.
          throw 'We are experiencing issues.  Please try again in a few minutes.'
        } else {
          // The setup has succeeded. Display a success message.
        }
      })
  }

  getSessionIDStored() {
    return localStorage.getItem('session_id')
  }

  storeSession(id) {
    if (id !== undefined) {
      localStorage.setItem('session_id', id)
    }
  }
}

export let stripe = new Stripe()
